import templateUrl from "emun.blog/blog-view.htm";
import angular from "angular";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";
import form from "emun.blog/blog.formio";
import formioController from "webforms/formio/formio.controller";
import AutoQuery from "servicestack/auto-query/auto-query";

class controller {
  constructor($scope, options) {
    const $ctrl = this;
    formioController($ctrl, $scope);
    $ctrl.bus = new ServiceBus();
    $ctrl.form = form;
    $ctrl.title = options.title || " Corporate Message...";
  	$ctrl.blog = options.blog || {};
    if ($ctrl.blog.id) $ctrl.bus.read(`QueryBlogs?Id=${$ctrl.blog.id}`).then(function(args) {
      if (parseInt($ctrl.$session.storage.NewMessages) > 0) $ctrl.$session.storage.NewMessages = parseInt($ctrl.$session.storage.NewMessages - 1);
    });

  }

}

export default {
  open(options) {
    return modals.open(
      Object.assign(
        {
          templateUrl,
          resolve: {
            options: () => options
          },
          bindToController: true,
          controller,
		  controllerAs: "$ctrl",
		  size: 'lg'
        },
        (options || {}).modal
      )
    ).result;
  }
};
